import util from '../util'

const controller = 'Impressao'
export default Object.assign({}, util.GetCrud(controller, ['getall']), {
  Get: function (dto) {
    return util.Axios.GetBlob(controller, dto)
  },
  GetAll: function (dto) {
    return util.Axios.GetAll(controller + '/GetAllComprovantes', dto)
  }
})
